import { Action } from '@ngrx/store';
import { Country } from '@app/models/country';

export enum CountryActionTypes {
  Load = '[Country] Load',
  LoadSuccess = '[Country] Load Success',
  LoadFail = '[Country] Load Fail',
  Select = '[Country] Select'
}

export class Load implements Action {
  readonly type = CountryActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = CountryActionTypes.LoadSuccess;
  constructor(public countries: Country[]) {}
}

export class LoadFail implements Action {
  readonly type = CountryActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class Select implements Action {
  readonly type = CountryActionTypes.Select;
  constructor(public id: number) {}
}

export type CountryActionsUnion = Load | LoadSuccess | LoadFail | Select;
